// ============================================================
// TPSSection.tsx
// Stage 3 redesign (approved mockup casevo-case-sections-batch2.html):
// the shared "party contact" card section — see
// components/case/sections/PartyContactSection.tsx. Fields, fieldKeys,
// address-lookup broadcast, the Yjs notes doc `case:<id>:tpsNotes`
// and mark-complete ('tps') are exactly as the old long form.
// ============================================================
import React from 'react'
import PartyContactSection, { type PartyConfig } from '../case/sections/PartyContactSection'

const CONFIG: PartyConfig = {
  prefix: 'tps',
  sectionKey: 'tps',
  title: 'Third-party solicitor (TPS)',
  sub: 'The solicitor acting for the defendant.',
  cardTitle: 'Third-party solicitor',
  icon: 'scale',
  nameLabel: 'Solicitor name',
  nameKey: 'tps.solicitor-name',
  who: 'the third-party solicitor',
  notesPlaceholder: 'Notes about the third-party solicitor…',
  readySub: 'No required fields.',
}

const TPSSection: React.FC = () => <PartyContactSection config={CONFIG} />
export default TPSSection
